<template>
  <div :class="$style.modal">
    <div :class="$style.modalContent">
      <ModalHeader
        :handleClose="handleClose"
        :headerText="header"
      />
      <div
        :class="$style.modalBody"
        data-test-id="mdmModalBody"
      >
        <div v-if="body.length">
          <ParagraphBody
            v-for="text in body"
            :key="text"
          >
            <MarkdownInline :mdTemplate="text" />
          </ParagraphBody>
        </div>
        <slot v-else />
      </div>
      <ModalFooter
        cancelText="cancel"
        :enableMainAction="enableMainAction"
        :handleClose="handleClose"
        :handleMainAction="handleAction"
        :kbLink="kbLink"
        :mainActionAttention="true"
        :mainActionText="actionText"
      />
    </div>
  </div>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { MarkdownInline, ParagraphBody } from '@jumpcloud/ui-components';
import { notify } from 'client/util';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import ModalFooter from 'client/components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'client/components/Modal/ModalComponents/ModalHeader.vue';

const { error, success } = Constants.default;

export default {
  name: 'SystemMdmCommandsModal',

  components: {
    MarkdownInline,
    ParagraphBody,
    ModalHeader,
    ModalFooter,
  },

  props: {
    actionEvent: {
      required: true,
      type: String,
    },
    actionText: {
      required: true,
      type: String,
    },
    body: {
      required: false,
      type: Array,
      default: () => [],
    },
    enableMainAction: {
      required: false,
      type: Boolean,
      default: true,
    },
    executeAction: {
      required: true,
      type: Function,
    },
    header: {
      required: true,
      type: String,
    },
    kbLink: {
      required: false,
      type: String,
      default: '',
    },
    onSuccess: {
      required: false,
      type: String,
      default: '',
    },
  },

  methods: {
    handleAction() {
      this.executeAction()
        .then(() => {
          ModalEventBus.$emit(this.actionEvent);
          if (this.onSuccess.length > 0) notify(success, this.onSuccess);
        })
        .catch(() => {
          notify(error, 'An error occurred while attempting to perform this action.');
        })
        .finally(() => {
          ModalEventBus.close();
        });
    },
    handleClose() {
      ModalEventBus.close();
    },
  },
};
</script>

<style module>
@import "../components/Modal/css/ModalStyles.css";

@value (white, gradientLight4) from '~css/colors.css';

.list {
  counter-reset: list-counter;
  list-style-type: none;
  padding: 0;
}

.listItem {
  background-color: white;
  box-shadow: 0 0 8px 0.5px gradientLight4;
  margin-bottom: 10px;
  padding: 15px;
  position: relative;
}

.fileContainer {
  height: 150px;
}
</style>
